import React from 'react';
import "./styles/Loader.css"

const Loader = ({ type="ellipse", color="#008000",size=50}) => {
    const tf = `${size/(200/(type==="ellipse"?80:6))}px ${size/(200/(type==="ellipse"?82:52))}px`
    const divStyle=type==="ellipse"?{
            boxShadow:`0 4px 0 0 ${color}`,
            WebkitTransformOrigin:tf,
            msTransformOrigin:tf,
            transformOrigin:tf,
            width:size/(200/160),
            height:size/(200/160),
          }:{
            background:color,
            WebkitTransformOrigin:tf,
            msTransformOrigin:tf,
            transformOrigin:tf,
            width:size/(200/12),
            height:size/(200/24),
            left: size/2,
            top: size/(200/52),
          }
    return (
        type==="ellipse"?
        <div className="khula-loader lds-eclipse" style={{width:size,height:size,display:'flex',justifyContent:'center',alignItems:'center'}}>
            <div style={divStyle}></div>
        </div>:
        <div className="khula-loader lds-spinner" style={{width:size,height:size}}>
            <div style={{...divStyle}}></div>
            <div style={divStyle}></div>
            <div style={divStyle}></div>
            <div style={divStyle}></div>
            <div style={divStyle}></div>
            <div style={divStyle}></div>
            <div style={divStyle}></div>
            <div style={divStyle}></div>
            <div style={divStyle}></div>
            <div style={divStyle}></div>
            <div style={divStyle}></div>
            <div style={divStyle}></div>
        </div>
    )
}

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader.js